import ApiService from "@/assets/js/api.service";

export const ACT_GET_INSTRUCTOR_LIST = 'getInstructorList';
export const ACT_GET_INSTRUCTOR_DETAIL = 'getInstructorDetail';

const actions = {
  [ACT_GET_INSTRUCTOR_LIST](context, params) {
    return new Promise(resolve => {
      ApiService.query('/v1/app/instructor/list', params).then(response => resolve(response))
    });
  },
  
  [ACT_GET_INSTRUCTOR_DETAIL](context, instructorId) {
    return new Promise(resolve => {
      ApiService.get(`/v1/app/instructor/detail/${instructorId}`).then(response => resolve(response))
    });
  },
}

export default {
  namespaced: true,
  actions
}; 